import { stdObject } from "../../../data/types/stdObject";
import { toPrice } from "../../../utils/toPrice";

export const updateDocTransferValue = (
  index: number,
  key: string,
  value: boolean | string | number,
  packs: stdObject,
) => {
  const { modalData, setModalData, items, docValues, country } = packs;
  const tempValues = modalData;
  if (index === -1) {
    tempValues[key] = value;
  } else {
    if (key === "quantity" && typeof value === "string") {
      value = Number(value);
      if (value > tempValues.items[index].maxQuantity) {
        value = tempValues.items[index].maxQuantity;
      }
      if (typeof value === "number" && value < 0) {
        value = 0;
      }
    }
    tempValues.items[index][key] = value;
    if (key === "active") {
      tempValues.items[index].quantity = value ? value : 0;
    }
    tempValues.PCO = tempValues.items
      .filter((e: stdObject) => e.active)
      .reduce(
        (acc: number, curr: stdObject) =>
          acc +
          (items[curr[`ART${docValues.itemType}`]]?.PREPCO[country] ?? 0) *
            curr.quantity,
        0,
      );
    tempValues.NET = tempValues.items
      .filter((e: stdObject) => e.active)
      .reduce(
        (acc: number, curr: stdObject) =>
          acc + curr[`PRE${docValues.itemType}`] * curr.quantity,
        0,
      );
    tempValues.IMP = tempValues.items
      .filter((e: stdObject) => e.active)
      .reduce(
        (acc: number, curr: stdObject) =>
          acc +
          (curr["PRE" + docValues.itemType] *
            curr["IMP" + docValues.itemType] *
            curr.quantity) /
            100,
        0,
      );
    tempValues.TOT = toPrice(tempValues.NET + tempValues.IMP);
    tempValues.NET = toPrice(tempValues.NET);
    tempValues.IMP = toPrice(tempValues.IMP);
  }

  tempValues.open = tempValues.items.some(
    (e: stdObject) => e.active && e.quantity > 0,
  );
  setModalData({ ...tempValues });
};
